/**
 * Grapheme-cluster helpers (UX-01 4.6 rule 3; SA-01 DI-25). Thai text must never be counted or cut by
 * UTF-16 length: a split between a consonant and its tone mark renders a dotted circle.
 */

const segmenter = typeof Intl !== "undefined" && "Segmenter" in Intl ? new Intl.Segmenter(undefined, { granularity: "grapheme" }) : undefined;

function clusters(text: string): string[] {
  if (segmenter) return Array.from(segmenter.segment(text), (s) => s.segment);
  return Array.from(text);
}

/** Grapheme clusters after NFC and trimming, the way reason(n) rules count. */
export function countGraphemes(text: string): number {
  return clusters(text.normalize("NFC").trim()).length;
}

export function truncateGraphemes(text: string, max: number): string {
  const parts = clusters(text);
  return parts.length <= max ? text : `${parts.slice(0, max).join("")}…`;
}
